import { useState, useEffect } from "react"
import toastError from "../../errors/toastError"

import api from "../../services/api"

const useTickets = ({
  filtro,
  situacoes,
  usuarios,
  pagina,
  status,
  dataCriacao,
  dataAtualizacao,
  filas,
  apenasNaoLidas,
  canais,
  lHabilitado = true,
}) => {
  const [loading, setLoading] = useState(true)
  const [hasMore, setHasMore] = useState(false)
  const [tickets, setTickets] = useState([])

  useEffect(() => {
    let lCancelado = false

    if (!lHabilitado) {
      setLoading(false)
      return undefined
    }
    setLoading(true)

    const fetchTickets = async () => {
      try {
        const { data } = await api.get("/tickets", {
          params: {
            filtro,
            pagina,
            situacoes,
            usuarios,
            status,
            dataCriacao,
            dataAtualizacao,
            filas,
            apenasNaoLidas,
            canais,
          },
        })

        if (!lCancelado) {
          setTickets(data.tickets)
          setHasMore(data.hasMore)
          setLoading(false)
        }
      } catch (err) {
        if (!lCancelado) {
          setLoading(false)
          toastError(err)
        }
      }
    }

    fetchTickets()

    return () => {
      lCancelado = true
    }
  }, [
    filtro,
    situacoes,
    usuarios,
    pagina,
    status,
    dataCriacao,
    dataAtualizacao,
    filas,
    apenasNaoLidas,
    canais,
    lHabilitado,
  ])

  return { tickets, loading, hasMore }
}

export default useTickets
